var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Hallo ...")]),_c('h1',[_vm._v("Welcome "+_vm._s(_vm.user))]),_c('p',[_c('router-link',{attrs:{"to":{
        name: 'invoices',
      }}},[_vm._v("Invoices")])],1),_c('button',{staticClass:"btn",on:{"click":_vm.logOut}},[_vm._v("Log out")])])}
var staticRenderFns = []

export { render, staticRenderFns }